export default __webpack_public_path__ + "static/media/Bestand_EDV.b56d92ab.png";